export class AwsSourceAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "roleArn",
            "baseName": "roleArn",
            "type": "string",
            "format": ""
        },
        {
            "name": "organizationId",
            "baseName": "organizationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "metricsConfigRegion",
            "baseName": "metricsConfigRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "grantedServices",
            "baseName": "grantedServices",
            "type": "AwsGrantedServices",
            "format": ""
        },
        {
            "name": "services",
            "baseName": "services",
            "type": "AwsSourceServices",
            "format": ""
        },
        {
            "name": "regions",
            "baseName": "regions",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsSourceAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
